import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Tag } from '../tag/';

const SearchField = ({disabled, inputId, isSelected, onBlur, onChange, onFocus, onSelectionCleared, placeholder, value}) => {
	const inputRef = useRef(null);
	let refocusRef = useRef(false);

	useEffect(() => {
		refocusRef.current && inputRef.current && inputRef.current.focus();
		refocusRef.current = false;
	});

	const handleClearSelection = () => {
		onSelectionCleared();
		refocusRef.current = true;
	}

	function handleChange(e) {
    onChange && onChange(e.target.value);
  }

	const renderArtist = () => {
		if (value && isSelected && !disabled) {
			const tag = {
				name: value
			};
			return (
				<Tag
					tag={tag}
					onDelete={handleClearSelection}
				/>
			);
		} else {
			return (
				<input
					className="search-input"
          value={value || ''}
					onChange = {handleChange}//{e => debounceOnChange(e.target.value)}
					onFocus={onFocus}
					onBlur={(evt) => {
						onBlur && onBlur(evt.target.value);
					}}
					placeholder={placeholder}
					ref={inputRef}
					id={inputId}
					disabled={disabled}
					autoComplete="off"
				/>
			);
		}
	}

	return (
		<div>
			<div className="input-wrap">{renderArtist()}</div>
		</div >
	);

}

SearchField.propTypes = {
	disabled: PropTypes.bool,
	inputId: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onSelectionCleared: PropTypes.func,
	value: PropTypes.string
};

export default SearchField
